import React from "react";
import {
  Text as DefaultText,
  TextStyle,
  TextProps as RNTextProps,
} from "react-native";

interface TextProps extends RNTextProps {
  style?: TextStyle | TextStyle[];
}

export const Text: React.FC<TextProps> = (props) => {
  return <DefaultText {...props} />;
};
